import { CityEntity, CityLocalizedEntity } from 'src/store';

export interface JobEntity {
  id: string;
  title_en: string;
  title_de: string;
  slug: string;
  description_en: string;
  description_de: string;
  city: CityEntity;
  start_date: Date;
  type: JobTypes;
  only_german: boolean;
}

export interface JobLocalizedEntity
  extends Pick<
    JobEntity,
    Exclude<keyof JobEntity, 'title_en' | 'title_de' | 'description_en' | 'description_de' | 'city'>
  > {
  description: string;
  title: string;
  city: CityLocalizedEntity;
}

export enum JobTypes {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Internship = 'traineeship',
  DegreeProgram = 'integrated_degree_program',
  IndustrialTraining = 'industrial_training',
  BusinessManagement = 'business_management_training',
}
